<template>
    <div class="headerBar">
        <div class="menuBox" v-loading="headerLoading">
            <ul>
                <li 
                    :class="liClass==index?'current':''"
                    v-for="(item,index) in menuList"
                    :key="index"
                    @click="chooseMenu(index)"
                >{{item.cloName}}</li>
            </ul>
        </div>
        <div v-show='!headerLoading' class="logout">
            <el-popover
                trigger="hover">
                <p class='name' slot='reference'>账号：{{userName}}</p>
                <p style='text-align: center; cursor: pointer;' @click='logout'>退出登录</p>
            </el-popover>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            headerLoading:true,
            menuList: this.menu,
            liClass: 0,
            userName: localStorage.yth_userName
        }
    },
    props: [
        'menu'
    ],
    mounted() {
        // console.log(this.menu);
    },
    methods: {
        chooseMenu(index) {
            this.liClass = index;
            $bus.$emit('colMenuIndex',index);
        },
        logout() {
            localStorage.removeItem('accessToken');
            this.$router.push({
                path: '/login'
            })
        }
    },
    watch:{
       'menu'(val, oldVal){
           this.headerLoading = false;
           this.menuList = this.menu;
       }, 
    }
}
</script>

<style lang='scss' scoped>
.headerBar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    z-index: 10;
    box-shadow: 0 2px 3px #999;
    overflow: hidden;
    background: #545c64;
    .menuBox {
        height: 100%;
        ul {
            height: 100%;
            display: flex;
            align-items: center;
            li {
                height: 100%;
                padding: 0 30px;
                display: flex;
                align-items: center;
                color: #fff;
                cursor: pointer;
                &.current {
                    background: rgba(0, 0, 0, 0.2);
                }
                &:hover {
                    background: rgba(0, 0, 0, 0.2);
                }
            }
        }
    }
    .logout {
        position: absolute;
        top: 0;
        right: 30px;
        color: #fff;
        cursor: pointer;
        
        .name {
            line-height: 70px;
            padding: 0 30px;
            &:hover {
                background: rgba(0, 0, 0, 0.2);
            }
        }
    }
}
</style>